(function(){
  function qs(root, sel){ return root.querySelector(sel); }
  function qsa(root, sel){ return Array.from(root.querySelectorAll(sel)); }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-pw-gallery]').forEach(function(gallery){
      var triggers = qsa(gallery, '.pw-media-zoomtrigger');
      if(!triggers.length) return;

      var modal = qs(gallery, '[data-pw-zoom]');
      var imgEl = qs(gallery, '[data-pw-zoom-img]');
      var thumbsWrap = qs(gallery, '[data-pw-zoom-thumbs]');

      var btnClose = qsa(gallery, '[data-pw-zoom-close]');
      var btnPrev = qs(gallery, '[data-pw-zoom-prev]');
      var btnNext = qs(gallery, '[data-pw-zoom-next]');

      var items = triggers.map(function(t){
        return {
          src: t.getAttribute('data-pw-zoom-src'),
          alt: t.getAttribute('data-pw-zoom-alt') || ''
        };
      });

      var index = 0;
      var lastFocus = null;

      function renderThumbs(){
        thumbsWrap.innerHTML = '';
        items.forEach(function(it, i){
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'View image ' + (i+1));
          b.addEventListener('click', function(){ setIndex(i); });

          var im = document.createElement('img');
          im.loading = 'lazy';
          im.alt = it.alt || '';
          im.src = it.src; // ok (Shopify CDN)
          b.appendChild(im);

          thumbsWrap.appendChild(b);
        });
      }

      function syncThumbs(){
        var buttons = thumbsWrap.querySelectorAll('button');
        buttons.forEach(function(b, i){
          b.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function setIndex(i){
        index = (i + items.length) % items.length;
        imgEl.src = items[index].src;
        imgEl.alt = items[index].alt || '';
        syncThumbs();
      }

      function openAt(i){
        if(!modal) return;
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';

        if(!thumbsWrap.children.length) renderThumbs();
        setIndex(i);

        // focus close for accessibility
        var c = qs(gallery, '.pw-zoom__close');
        if(c) c.focus();
      }

      function close(){
        if(!modal) return;
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        if(lastFocus && lastFocus.focus) lastFocus.focus();
      }

      triggers.forEach(function(t, i){
        t.addEventListener('click', function(){ openAt(i); });
      });

      btnClose.forEach(function(b){ b.addEventListener('click', close); });

      if(btnPrev) btnPrev.addEventListener('click', function(){ setIndex(index - 1); });
      if(btnNext) btnNext.addEventListener('click', function(){ setIndex(index + 1); });

      document.addEventListener('keydown', function(e){
        if(!modal || modal.hidden) return;
        if(e.key === 'Escape') close();
        if(e.key === 'ArrowLeft') setIndex(index - 1);
        if(e.key === 'ArrowRight') setIndex(index + 1);
      });
    });
  });
})();
